import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private reason: string = '';
  private checkboxSelection = false;
  private contractName: string = '';
  public showOperatorPage = new BehaviorSubject<boolean>(true);
  showOperatorPage$ = this.showOperatorPage.asObservable();
  hideSidebar: boolean = false;
  file!: any;

  /**
   * @constructor
   * @param {HttpClient} http : Http client for API calls
   */
  constructor() {}

  saveReason(reason: string) {
    this.reason = reason;
  }

  getReason() {
    return this.reason;
  }

  saveSelection(selection: boolean) {
    this.checkboxSelection = selection;
  }

  getSelection() {
    return this.checkboxSelection;
  }

  showOperatorsPages() {
    console.log('here');
    this.showOperatorPage.next(false);
    this.showOperatorPage$ = this.showOperatorPage.asObservable();
    this.hideSidebar = true;
  }

  hideOperatorsPages() {
    this.showOperatorPage.next(true);
    this.showOperatorPage$ = this.showOperatorPage.asObservable();
    this.hideSidebar = false;
  }

  saveContract(contractName: string) {
    this.contractName = contractName;
  }

  getContract() {
    return this.contractName;
  }

  setFile(file: any) {
    this.file = file;
  }

  getFile() {
    return this.file;
  }
}
